import {
  clearClientToken,
  getClientToken,
  setClientToken,
} from 'lib/auth/token';

function getSafeLocalStorage() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const { localStorage } = window;
    if (localStorage && typeof localStorage.getItem === 'function') {
      return localStorage;
    }
  } catch {
    return null;
  }

  return null;
}

const themeKey = 'theme';
const currentRegionKey = 'curentRegion';
const regionManuallySelectedKey = 'regionManuallySelected';

// utm_source,
// utm_medium,
// utm_campaign,
// utm_content,
// utm_term,

const utmSourceKey = 'utm_source';
const utmMediumKey = 'utm_medium';
const utmCampaignKey = 'utm_campaign';
const utmContentKey = 'utm_content';
const utmTermKey = 'utm_term';
const referrerKey = 'session_source';

export const clearToken = () => clearClientToken();

export const clearAll = () => {
  clearToken();
};

export const saveToken = (token: string) => {
  setClientToken(token);
};

export const getToken = () => {
  return getClientToken();
};

export const saveDarkTheme = (isDarkTheme?: boolean) => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  if (typeof isDarkTheme === 'boolean') {
    storage.setItem(themeKey, String(isDarkTheme));
  } else {
    storage.removeItem(themeKey);
  }
};

export const getIsDarkTheme = (): boolean | undefined => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return undefined;
  }

  const isDarkTheme = storage.getItem(themeKey);
  if (isDarkTheme === null) return undefined;
  return isDarkTheme === 'true';
};

export const saveCurrentRegion = (currentRegion?: string | null) => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  storage.setItem(currentRegionKey, String(currentRegion));
};

export const getCurrentRegion = (): string | undefined | null => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return null;
  }

  const value = storage.getItem(currentRegionKey);
  if (value === 'undefined') {
    return null;
  }
  return value;
};

export const setRegionManuallySelected = (value: boolean) => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  storage.setItem(regionManuallySelectedKey, String(value));
};

export const getIsRegionManuallySelected = (): string | undefined | null => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return null;
  }

  const value = storage.getItem(regionManuallySelectedKey);
  if (value === 'undefined') {
    return null;
  }
  return value;
};

export const saveRefferer = (value: string) => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  storage.setItem(referrerKey, value);
};

export const clearRefferer = () => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(referrerKey);
};

export const saveUtm = (utm: Record<string, string>) => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  if (utm.utm_source) {
    storage.setItem(utmSourceKey, utm.utm_source);
  }
  if (utm.utm_medium) {
    storage.setItem(utmMediumKey, utm.utm_medium);
  }
  if (utm.utm_campaign) {
    storage.setItem(utmCampaignKey, utm.utm_campaign);
  }
  if (utm.utm_content) {
    storage.setItem(utmContentKey, utm.utm_content);
  }
  if (utm.utm_term) {
    storage.setItem(utmTermKey, utm.utm_term);
  }
};

export const clearUtm = () => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(utmSourceKey);
  storage.removeItem(utmMediumKey);
  storage.removeItem(utmCampaignKey);
  storage.removeItem(utmContentKey);
  storage.removeItem(utmTermKey);
};

export const getUtm = (): Record<string, string | null> => {
  const storage = getSafeLocalStorage();
  if (!storage) {
    return {};
  }

  return {
    utm_source: storage.getItem(utmSourceKey),
    utm_medium: storage.getItem(utmMediumKey),
    utm_campaign: storage.getItem(utmCampaignKey),
    utm_content: storage.getItem(utmContentKey),
    utm_term: storage.getItem(utmTermKey),
    referrer: storage.getItem(referrerKey),
  };
};
